
export enum AssetSaleFieldInfoTooltip {

  forcedConsensus = 'The expected selling price of each asset as determined by a Sr Valuation Analyst or experienced member of the pricing team. Value is set during pricing process.',
  shootPrice = 'An estimate of what we think the item will sell for in one of our platforms.',
  reservePrice = 'The lowest price the Consignor will accept for the item. The Consignor will not be required to sell below this price.',
  notifyPrice = 'The value that the Consignor & TM want to start receiving notifications of Buyer offers via email.',
  rejectPrice = 'Offers made at or below the Reject Price will not show up on our Web Site or in the Consignor’s email or "My Account". The Buyer will receive an automatic "reject/thank you" notice.',
  buyItNowprice = 'The price that the Consignor will take for their item without negotiation. If bidder selects this option, the item will immediately sell at this price.',

}
